import React from 'react';
import './Emptytodos.css';

function EmptyTodos() {
  return (
    <div className="EmptyTodos-container">
      <p className="EmptyTodos-text">¡Crea tu primer TODO!</p>
    </div>
  );
}

export { EmptyTodos };